import React from "react";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import withRouter from "../withRouter";
import maplibregl from "maplibre-gl";
import {
    Map,
    Source,
    Layer,
    Marker,
    FullscreenControl,
    NavigationControl,
} from "@vis.gl/react-maplibre";
import config from "../config";
import { Button, Card, Checkbox, Col, DatePicker, Form, Image, Input, message, Modal, Row, Select, Space, Table, Tooltip } from "antd";
import AddGeofenceFields from "./Plugins/AddGeofence/AddGeofenceFields";
import CompanyAutocomplete from "./CompanyAutocomplete";
import Autocomplete from "react-google-autocomplete";
import dayjs from "dayjs";
import { CloseOutlined, DeleteFilled, DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import Draggable from "react-draggable";
import searchIcon from "../assets/images/NewDesign/livetracking/SearchIcon.svg";
import AddVersionModal from "./Plugins/AddGeofence/AddVersionModal";
import LiveTrackingStore from "../store/LiveTrackingStore";
import { Link } from "react-router-dom";
import DeleteConfirm from "./DeleteConfirm";
import CompanyStore from "../store/CompanyStore";
import * as turf from "@turf/turf";
import DrawControl from "./DrawControl";

const { Option } = Select;

const studentClusterLayer = {
    id: "student-clusters",
    type: "circle",
    source: "student-source",
    filter: ["has", "point_count"],
    paint: {
        "circle-color": [
            "step", ["get", "point_count"],
            "#51bbd6", 50,
            "#f1f075", 100,
            "#f28cb1",
        ],
        "circle-radius": [
            "step", ["get", "point_count"],
            20, 50,
            30, 100,
            40,
        ],
        "circle-stroke-width": 2,
        "circle-stroke-color": "#ffffff",
    },
};

const studentClusterCountLayer = {
    id: "student-cluster-count",
    type: "symbol",
    source: "student-source",
    filter: ["has", "point_count"],
    layout: {
        "text-field": "{point_count_abbreviated}",
        "text-font": ["Open Sans Regular"],
        "text-size": 12,
        "text-allow-overlap": true,
    },
    paint: {
        "text-color": "#000000",
        "text-halo-color": "#ffffff",
        "text-halo-width": 0.2,
    },
};

const studentPointLayer = {
    id: "student-unclustered-point",
    type: "circle",
    source: "student-source",
    filter: ["!", ["has", "point_count"]],
    paint: {
        "circle-color": "#ff0000",
        "circle-radius": 6,
        "circle-stroke-width": 1,
        "circle-stroke-color": "#ffffff",
    },
};

class PlotStudentsOnMap extends React.Component {
    constructor(props, context) {
        super(props);
        this.mapRef = null;
        this.state = {
            viewState: {
                longitude: config.mapCenter[1],// 46.6753,
                latitude: config.mapCenter[0],//24.7136,
                zoom: config.mapZoom,
                drawGeofence: false,
                showGeofence: false,
                GeofancenType: "",
                zoneId: -1,
                companyId: null,
                searchGeoFence: "",
                pageSize: 50,
                currentPage: 1,
                offset: 0,
                limit: 50,
                centerLatLng: {},
                company_value: ''
            },
        };
        this.handleTableChange = this.handleTableChange.bind(this);

        this.liveTrackingStore = new LiveTrackingStore(this);
        this.companyStore = new CompanyStore(this);
        this.formRef = React.createRef();
        this.pendingGeofence = {};

        this.showGeofenceListColumn = [
            {
                title: context.translate("_FLEET_DASHBORD_NEWPOI_NAME_"),
                dataIndex: "name",
                render: (_, record) => {
                    return <>{_}</>;
                },
            },
            {
                title: context.translate("_FLEET_DASHBORD_NEWPOI_ADDRESS_"),
                dataIndex: "address",
            },
            {
                title: context.translate("_OPERATION_"),
                dataIndex: "operation",

                render: (_, val) => {
                    return (
                        <Space>
                            <Link
                                onClick={async () => {
                                    this.removePlottedGeofences();

                                    // Optional: clear checkbox selection
                                    this.setState({
                                        selectGeofenceInList: [],
                                        selectGeofenceRows: [],
                                        showGeofence: false,
                                        drawGeofence: true,
                                    });
                                    this.onEditGeofence(val);

                                    this.setState({ showGofence: false });
                                    if (this.state.company_value) {
                                        await this.geofenceCardTitle(
                                            this.context.translate("_UPDATE_GEOFENCE_"),
                                        );
                                    }
                                }}
                            >
                                <Tooltip
                                    // title="Edit Geofence"
                                    title={this.context.translate("_EDIT_GEOFENCE_")}
                                    placement="bottom"
                                    color={config.tooltipColorEdit}
                                >
                                    <EditOutlined style={{ fontSize: "15px" }} />
                                </Tooltip>
                            </Link>
                            <DeleteConfirm
                                onConfirm={(e) => {
                                    this.deleteGeofence(val);
                                }}
                            >
                                <Link
                                    onClick={(e) => {
                                        e.preventDefault();
                                    }}
                                >
                                    <Tooltip
                                        // title="Delete Geofence"
                                        title={this.context.translate(
                                            "_FLEET_DASHBORD_SHOWGEO_DELETE_",
                                        )}
                                        placement="bottom"
                                        color={config.tooltipColorDelete}
                                    >
                                        <DeleteFilled style={{ color: config.deleteColor }} />
                                    </Tooltip>
                                </Link>
                            </DeleteConfirm>
                        </Space>
                    );
                },
            },
        ];

    }

    buildStudentGeoJSON(data) {
        return {
            type: "FeatureCollection",
            features: (data || []).map((student) => ({
                type: "Feature",
                geometry: {
                    type: "Point",
                    coordinates: [
                        parseFloat(student.longitude),
                        parseFloat(student.latitude),
                    ],
                },
                properties: {
                    // id: student.pa,
                    name: student.studentName,
                },
            })),
        };
    }

    async componentDidUpdate(prevProps, prevState) {

    }

    searchInput = async (e) => {
        const value = e.target.value;
        if (value.length > 2 || value.length === 0) {
            if (this.state.companyId) {
                await this.liveTrackingStore.getGofenceList({
                    companyId: this.state.companyId,
                    searchField: value,
                    offset: 0,
                    limit: this.state.pageSize,
                });
                await this.setState({ loadList: 1 });
            }
        }
    };
    async componentDidMount() {
        if (
            Number(this.props.getUserData().isadmin) !== -1 &&
            Number(this.props.getUserData().isadmin) !== 3
        ) {
            await this.setState({
                companyId: this.props.getUserData().userCompanyId,
            });
        }
    }
    onEditGeofence = async (val) => {
        console.log(val, "val")
        this.pendingGeofence = val;
        this.setState({
            selectGeofenceObjects: [],
            drawGeofence: true,
            editing: true,
            zoneId: val.zoneId,
            showGeofence: false
        });
        await this.liveTrackingStore.poiCurrentVehicleUsingCompanyId({
            companyId: val.companyId,
        });
        await this.liveTrackingStore.getVehiclesUsingCompanyId({
            companyId: val.companyId,
        });

        // this.loadGeofenceIntoDraw(val);
        // await this.setPointsInArrayFormat([val], true);
        const singleData = await this.companyStore.getCompanyDataById(
            val.companyId,
        );
        await this.setState({
            companyId: val.companyId,
            drawGeoLocation: val.address,
            drawingBounds: val.points,
        });
        // console.log(singleData,);

        await this.liveTrackingStore.getGofenceList({
            companyId: this.state.companyId,
        });
        await this.formRef.current.setFieldsValue({
            typeName: val?.typeName ? parseInt(val?.typeName) : null,
            geosettingname: val?.name,
            companyId: singleData,
            address: val?.address,
            speed: val?.speed,
            bigPrice: val?.bigPrice,
            bigNeightPrice: val?.bigNeightPrice,
            neightPrice: val?.neightPrice,
            special: val?.special,
            speedDuration: val?.spdur,
            vendorId: val?.vendorId,
            price: val?.price,
            // type: val?.type,

            // drawGeoLocation:val.address
        });

        await this.setState({
            company_value: singleData,
            GeofancenType: val?.type,
            radius: val?.radius,
        });
    };
    geofenceCardTitle = async (title) => {
        await this.setState({ geofenceTitle: title });
    };

    runWhenMapReady = (cb) => {
        if (!this.mapRef) return;

        if (this.mapRef.isStyleLoaded()) {
            cb();
        } else {
            this.mapRef.once("styledata", cb);
        }
    };

    showGeofencesOnMap = (selectedRows) => {
        console.log(selectedRows, "selectedRows")
        if (!this.mapRef || !Array.isArray(selectedRows)) return;

        this.runWhenMapReady(() => {
            const map = this.mapRef;

            ["geofence-fill", "geofence-outline"].forEach((id) => {
                if (map.getLayer(id)) map.removeLayer(id);
            });

            if (map.getSource("geofence-source")) {
                map.removeSource("geofence-source");
            }

            const features = [];

            for (const row of selectedRows) {
                // Convert "lat,lng,0,lat,lng,0" → [[lat,lng], ...]
                const nums = row.points
                    .split(",")
                    .map(Number)
                    .filter((_, idx) => idx % 3 !== 2);

                const coords = [];
                for (let i = 0; i < nums.length; i += 2) {
                    coords.push([nums[i + 1], nums[i]]); // [lng, lat]
                }

                //  Circle
                let geometry = null;

                if (coords.length === 1) {
                    const radius = row.radius || 100;
                    geometry = turf.circle(coords[0], radius / 1000, {
                        steps: 64,
                        units: "kilometers",
                    }).geometry;
                }

                // Rectangle
                else if (coords.length === 2) {
                    const bounds = turf.bboxPolygon([
                        Math.min(coords[0][0], coords[1][0]),
                        Math.min(coords[0][1], coords[1][1]),
                        Math.max(coords[0][0], coords[1][0]),
                        Math.max(coords[0][1], coords[1][1]),
                    ]);
                    geometry = bounds.geometry;
                }

                // Polygon
                else if (coords.length > 2) {
                    // close polygon
                    if (
                        coords[0][0] !== coords[coords.length - 1][0] ||
                        coords[0][1] !== coords[coords.length - 1][1]
                    ) {
                        coords.push(coords[0]);
                    }

                    geometry = {
                        type: "Polygon",
                        coordinates: [coords],
                    };
                }

                if (!geometry) continue;

                features.push({
                    type: "Feature",
                    geometry,
                    properties: {
                        zoneId: row.zoneId,
                        name: row.name,
                    },
                });
            }

            if (!features.length) return;

            // Add GeoJSON source
            map.addSource("geofence-source", {
                type: "geojson",
                data: {
                    type: "FeatureCollection",
                    features,
                },
            });

            //  Fill layer
            map.addLayer({
                id: "geofence-fill",
                type: "fill",
                source: "geofence-source",
                paint: {
                    "fill-color": "#ff0000",
                    "fill-opacity": 0.3,
                },
            });

            //  Outline layer
            map.addLayer({
                id: "geofence-outline",
                type: "line",
                source: "geofence-source",
                paint: {
                    "line-color": "#ff0000",
                    "line-width": 2,
                },
            });

            // Zoom to all geofences
            const bbox = turf.bbox({
                type: "FeatureCollection",
                features,
            });

            map.fitBounds(bbox, { padding: 60, duration: 800 });
        });
    };



    handleMapLoad = (e) => {
        const map = e.target;
        this.mapRef = map;

        // Create a single reusable popup
        this.hoverPopup = new maplibregl.Popup({
            closeButton: false,
            closeOnClick: false,
            offset: [0, -10],
        });

        // Show tooltip on hover
        map.on("mouseenter", "student-unclustered-point", (e) => {
            map.getCanvas().style.cursor = "pointer";

            const coordinates = e.features[0].geometry.coordinates.slice();
            const { name } = e.features[0].properties;

            // Handle map wrap-around
            while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
            }

            this.hoverPopup
                .setLngLat(coordinates)
                .setHTML(`
                <div style="
                    padding: 6px 10px;
                    font-size: 13px;
                    font-weight: 500;
                    color: #1f2937;
                    white-space: nowrap;
                ">
                    ${name || "Unknown"}
                </div>
            `)
                .addTo(map);
        });

        map.on("mouseleave", "student-unclustered-point", () => {
            map.getCanvas().style.cursor = "";
            this.hoverPopup.remove();
        });

        // Optional: show count tooltip on cluster hover
        map.on("mouseenter", "student-clusters", (e) => {
            map.getCanvas().style.cursor = "pointer";

            const coordinates = e.features[0].geometry.coordinates.slice();
            const count = e.features[0].properties.point_count;

            this.hoverPopup
                .setLngLat(coordinates)
                .setHTML(`
                <div style="
                    padding: 6px 10px;
                    font-size: 13px;
                    font-weight: 500;
                    color: #1f2937;
                    white-space: nowrap;
                ">
                    ${count} students
                </div>
            `)
                .addTo(map);
        });

        map.on("mouseleave", "student-clusters", () => {
            map.getCanvas().style.cursor = "";
            this.hoverPopup.remove();
        });
    };

    onFinishDrawing = async (values) => {
        if (
            this.state.companyId &&
            this.state.drawingBounds
        ) {
            // console.log(this.state.companyId,
            //     this.state.drawingBounds)
            const data = {
                ...values,
                GeofancenType: this.state.GeofancenType,
                zoneId: this.state.zoneId,
                isactive: 1,
                createdBy: 1,
                radius: this.state.radius,
                bound: this.state.drawingBounds,
                companyId: this.state.companyId,
                latitude: this.state.centerLatLng.lat,
                longitude: this.state.centerLatLng.lng
            };

            // console.log(data, "dta")
            const response = await this.liveTrackingStore.addGeofenceDrawing(data);

            if (response?.data?.success === "S") {
                message.success("Geofence saved successfully");

                this.removePlottedGeofences();

                this.setState({
                    selectGeofenceInList: [],
                    selectGeofenceRows: [],
                });
                await this.liveTrackingStore.getGofenceList({
                    companyId: this.state.companyId,
                    offset: 0,
                    limit: 50,
                });
                // this.handleCompanyChange()

                const singleData = await this.companyStore.getCompanyDataById(
                    this.state.companyId,
                );

                await this.setState({ drawGeofence: false });
                await this.setState({ showGofence: true, company_value: singleData });

                await this.clearFields();
            } else {
                message.error();
            }
        } else {
            Modal.warning({
                title: this.context.translate("_FLEET_ALERT_"),
                content: this.context.translate("_SELECT_SHAPE_DRAW_FENCE_"),
            });
        }
        await this.setState({ listUpdated: 1 });
    };

    onGeofenceCreate = (data) => {
        console.log(data, "data")
        // shapeType === "circle" ? 2 : shapeType === "rectangle" ? 1 : 3
        this.setState({
            drawingBounds: data.drawingBounds,
            GeofancenType:
                data.type === "circle" ? 2 : data.type === "rectangle" ? 1 : 3,
            radius: data.radius,
            centerLatLng: data?.center
        });

        // optional auto-fill address
        this.formRef?.current?.setFieldsValue({
            address: data.address,
        });
    };

    onGeofenceUpdate = (data) => {
        console.log(data, "datta")
        this.setState({
            drawingBounds: data.drawingBounds,
            // GeofancenType:
            //   data.type === "circle" ? 2 : data.type === "rectangle" ? 1 : 3,

            radius: data.radius,
            centerLatLng: data?.center
        });
    };

    async handleTableChange(pagination, filters, sorter) {
        console.log(pagination,)
        await this.setState({
            currentPage: pagination.current,
            pageSize: pagination.pageSize,
        });
        await this.handleCompanyChange();
    }

    handleCompanyChange = async () => {
        await this.liveTrackingStore.getGofenceList({
            companyId: this.state.companyId,
            offset: (this.state.currentPage - 1) * this.state.pageSize,
            limit: this.state.pageSize,
        });
        // console.log(offset,limit)
        this.setState({ loadData: 1 });
    };

    removePlottedGeofences = () => {
        if (this.drawRef) {
            this.drawRef.deleteAll();
        }

        if (!this.mapRef) return;

        // Remove layers
        ["geofence-fill", "geofence-outline"].forEach((layerId) => {
            if (this.mapRef.getLayer(layerId)) {
                this.mapRef.removeLayer(layerId);
            }
        });

        // Remove source
        if (this.mapRef.getSource("geofence-source")) {
            this.mapRef.removeSource("geofence-source");
        }
    };
    clearFields = () => {
        this.setState({ radius: "", drawingBounds: [] });
        this.formRef.current.setFieldsValue({
            speed: "",
            address: "",
            typeName: "",
            geosettingname: "",
            vehicleId: "",
            companyId: "",
        });
        this.setState({ vehicleId: "" });
    };


    deleteGeofence = async (val) => {
        let zoneId = [val?.zoneId];
        let response;
        for (let i = 0; i < zoneId.length; i++) {
            response = await this.liveTrackingStore.deleteGeofence({
                zoneId: zoneId[i],
                companyId: val.companyId,
            });
        }
        if (response?.data?.success === "S") {
            message.success(response.data.message);

            this.setState({ selectGeofenceObjects: [] });

            await this.liveTrackingStore.getGofenceList({
                companyId: val.companyId,
                offset: (this.state.currentPage - 1) * this.state.pageSize,
                limit: this.state.pageSize,
            });
            this.setState({ drawingBounds: [] });
        } else if (response?.data?.success === "F0") {
            message.error(response.data.errors[0].geodeleteerror);
        }
        await this.setState({ listUpdated: 1 });
    };

    handleGetGofenceList = async (comp) => {
        this.setState({ loading: true });
        // this.setState({ company_value: comp.value });
        await this.setState({
            company_value: { label: comp.label, value: comp.value },
        });


        await this.liveTrackingStore.getGofenceList({
            companyId: comp.value,
            offset: 0,
            limit: 50,
        });

        await this.setState({ listUpdated: 1 });
        this.setState({ loading: false });
    };
    handleChangeForDrawingGeofence = async (comp) => {
        await this.setState({ companyId: comp.value });
        await this.liveTrackingStore.getVehiclesUsingCompanyId({
            companyId: comp.value,
        });
        await this.formRef.current.setFieldsValue({ companyId: comp.value });
        await this.liveTrackingStore.poiCurrentVehicleUsingCompanyId({
            companyId: comp.value,
        });
        await this.setState({ listUpdated: 1 });
    };
    render() {
        const studentsData = this.context.viewStateStore.mapStudents;
        const plotStudentsData = this.buildStudentGeoJSON(studentsData);
        const formItemStyle = { marginBottom: "2px", marginTop: "2px" };
        return (<>
            <Map
                mapLib={maplibregl}
                {...this.state.viewState}
                onMove={(e) => this.setState({ viewState: e.viewState })}

                onLoad={this.handleMapLoad}
                style={{ width: "100%", height: "92vh" }}
                mapStyle="https://basemaps.cartocdn.com/gl/voyager-gl-style/style.json"
                interactiveLayerIds={["student-clusters", "student-unclustered-point"]}
            >
                <NavigationControl
                    showCompass={false}
                    showZoom={true}
                    position="bottom-right"
                />

                <Source
                    id="student-source"
                    type="geojson"
                    data={plotStudentsData}
                    cluster={true}
                    clusterMaxZoom={18}
                    clusterRadius={20}
                    generateId={true}
                >
                    <Layer {...studentClusterLayer} />
                    <Layer {...studentClusterCountLayer} />
                    <Layer {...studentPointLayer} />
                </Source>

                {(this.mapRef &&
                    <div style={{
                        display: this.state.drawGeofence ? "block" : "none",
                    }}>
                        <DrawControl
                            map={this.mapRef}
                            position="top-left"
                            displayControlsDefault={false}
                            controls={{
                                polygon: true,
                                trash: true,
                            }}
                            pendingGeofence={this.pendingGeofence}
                            onDrawReady={(draw) => {
                                this.drawRef = draw;

                                // if (this.pendingGeofence) {
                                //     console.log("sdasdas", this.pendingGeofence)
                                //     this.loadGeofenceIntoDraw(this.pendingGeofence);
                                //     // this.pendingGeofence = null;
                                // }
                            }}
                            onGeofenceCreate={this.onGeofenceCreate}
                            onGeofenceUpdate={this.onGeofenceUpdate}
                        // geofenceformRef={this.props}
                        />
                    </div>
                )}
            </Map>
            {/* <Button style={{
                position: "absolute",
                top: "80px",
                right: "10px",
                zIndex: 1,
            }} onClick={() => {
                this.setState({ drawGeofence: true })
            }}>
                Add Geofence
            </Button> */}

            <Tooltip
                title="Show Geofence"
                placement="left"
            >
                <img
                    src={require("../assets/images/NewDesign/livetracking/hurricane.png")}
                    alt="Show Geofence"
                    style={{
                        position: "absolute",
                        top: "70px",
                        right: "10px",
                        zIndex: 999,
                        width: "35px",
                        height: "35px",
                        cursor: "pointer",
                        background: "#fff",
                        padding: "5px",
                        border: "1px solid #d9d9d9",
                        borderRadius: "8px",
                        boxShadow: "0px 2px 8px rgba(0,0,0,0.15)",
                    }}
                    onClick={async () => {
                        this.setState({
                            showGeofence: true,
                            drawGeofence: false,
                        });

                        this.removePlottedGeofences();

                        if (
                            Number(this.props.getUserData().isadmin) !== -1 &&
                            Number(this.props.getUserData().isadmin) !== 3
                        ) {
                            await this.liveTrackingStore.getGofenceList({
                                companyId: this.props.getUserData().userCompanyId,
                                offset: 0,
                                limit: 50,
                            });

                            this.setState({ loadData: 1 });
                        }
                    }}
                />
            </Tooltip>
            {/* <Button
                  style={{
                    position: "absolute",
                    top: "110px",
                    right: "10px",
                    zIndex: 1,
                }}
                onClick={async () => {
                    this.setState({
                        showGeofence: true,
                        drawGeofence: false, // hide draw controls
                    });

                    this.removePlottedGeofences();
                    await this.liveTrackingStore.getGofenceList({
                        companyId: this.props.getUserData().userCompanyId,
                        offset: 0,
                        limit: 50,
                    });
                    this.setState({ loadData: 1 })
                }}
            >
                Show Geofence
            </Button> */}
            {this.state.drawGeofence && (
                <div>
                    <Card
                        className="right-menu-panel-newGeofence"
                        // headStyle={{
                        //   margin: "0px !important",
                        //   padding: "0px !important",
                        // }}
                        title={
                            <div>
                                <p style={{ cursor: "move" }}>
                                    {/* New Geofence */}
                                    {this.context.translate(this.state.geofenceTitle)}
                                </p>
                                <div style={{ paddingBottom: "10px" }}>
                                    <Autocomplete
                                        className="autocomplete-location-textbox"
                                        // options={
                                        //   {
                                        //     types: ['geocode', 'establishment', 'address', 'locality', 'route'],
                                        //   }
                                        // }
                                        defaultValue={this.state.drawGeoLocation}
                                        onChange={(e) => {
                                            this.setState({ testState: e.target.value });
                                        }}
                                        componentRestrictions={{ country: "us" }}
                                        options={{
                                            types: ["geocode", "establishment"],
                                        }}
                                        style={{ fontSize: "14px", width: "97%", height: "45px" }}
                                        apiKey={config.googleMapKey}
                                        onPlaceSelected={async (e) => {
                                            await this.setState({
                                                drawGeoLocation: e.formatted_address,
                                            });
                                            await this.getInformationOfVehicle({
                                                latLong: {
                                                    latitude: e.geometry?.location?.lat(),
                                                    longitude: e.geometry?.location?.lng(),
                                                },
                                            });

                                            // await this.setState({update:1})
                                        }}
                                    // onPlaceSelected={(e) => {
                                    //   console.log(e);
                                    // }}
                                    />
                                </div>
                            </div>
                        }

                    // style={{ width: 400, padding: "20px" }}
                    >
                        <Form
                            onFinish={this.onFinishDrawing}
                            onFinishFailed={(a) => {
                                a.errorFields.forEach((val) => {
                                    val.name.forEach((val2) => {
                                        if (val2 === "address") {
                                            Modal.warning({
                                                // title: "Alert",
                                                title: this.context.translate("_FLEET_ALERT_"),
                                                // content: "We need to Draw Geofence for Address",
                                                content: this.context.translate(
                                                    "_SELECT_SHAPE_DRAW_FENCE_",
                                                ),
                                            });
                                        }
                                    });
                                });
                            }}
                            layout="vertical"
                            ref={this.formRef}
                        >
                            <div
                                style={{
                                    overflow: "auto",
                                    maxHeight: "395px",
                                    paddingInlineEnd: "12px",
                                    borderTop: "1px solid",
                                    marginTop: "5px solid",
                                }}
                            >
                                {(this.props.getUserData().isadmin === -1 ||
                                    this.props.getUserData().isadmin === 3) && (
                                        <Form.Item
                                            name="companyId"
                                            label={this.context.translate(
                                                "_FLEET_DASHBORD_NEWPOI_CUSTOMER_",
                                            )}
                                            rules={[{ required: true }]}
                                        >
                                            <CompanyAutocomplete
                                                // value={this.state.companyId}
                                                onChange={async (value) => {
                                                    await this.handleChangeForDrawingGeofence(value);
                                                    await this.setState({ companyId: value.value });
                                                }}
                                            />
                                        </Form.Item>
                                    )}
                                {/* <Form.Item
                                      label=" "
                                      name="vehicleLoc"
                                      className="checkbox-block"
                                    > */}
                                <br />
                                <Checkbox
                                    className="checkbox-block"
                                    checked={this.state.currentVehicleLoc}
                                    onChange={(e) =>
                                        this.setState({
                                            currentVehicleLoc: e.target.checked,
                                        })
                                    }
                                >
                                    {/* Current Vehicle Location */}
                                    {this.context.translate("_CURRENT_VEHICLE_LOCATION_")}
                                </Checkbox>
                                {/* </Form.Item> */}

                                <div
                                    style={{
                                        display: this.state.currentVehicleLoc ? "" : "none",
                                    }}
                                >
                                    <Form.Item
                                        // label="Vehicle No"
                                        label={this.context.translate("_VEHICLE_NO_")}
                                        name="vehicleId"
                                        style={formItemStyle}
                                    >
                                        <Select
                                            onSelect={(val, record) => {
                                                this.setState({ vehicleId: val });
                                                this.getInformationOfVehicle({ vehicleId: val });
                                            }}
                                            showSearch
                                            filterOption={(inputValue, option) => {
                                                if (option.children) {
                                                    return (
                                                        option.children
                                                            .toLowerCase()
                                                            .indexOf(inputValue.toLowerCase()) >= 0
                                                    );
                                                }
                                            }}
                                        >
                                            {this.liveTrackingStore?.vehiclePositionArray?.map(
                                                (val) => {
                                                    return (
                                                        <Option vehicleObj={val} value={val.vehicleId}>
                                                            {val.vehicleNo}
                                                        </Option>
                                                    );
                                                },
                                            )}
                                        </Select>
                                    </Form.Item>
                                </div>
                                <Form.Item
                                    // label="Address"
                                    label={this.context.translate(
                                        "_FLEET_DASHBORD_NEWPOI_ADDRESS_",
                                    )}
                                    name="address"
                                    style={formItemStyle}
                                    rules={[{ required: true }]}
                                >
                                    <Input disabled />
                                </Form.Item>
                                <Form.Item
                                    // label="Name"
                                    label={this.context.translate(
                                        "_FLEET_DASHBORD_NEWPOI_NAME_",
                                    )}
                                    name="geosettingname"
                                    style={formItemStyle}
                                    rules={[{ required: true }]}
                                >
                                    <Input />
                                </Form.Item>

                                {/* <Form.Item label=" " name="input5" className="checkbox-block"> */}
                                <br />
                                <Checkbox
                                    className="checkbox-block"
                                    checked={this.state.selectFormHistory}
                                    onChange={(e) =>
                                        this.setState({
                                            selectFormHistory: e.target.checked,
                                        })
                                    }
                                >
                                    {/* Select Form History */}
                                    {this.context.translate("_SELECT_FROM_HISTORY_")}
                                </Checkbox>
                                {/* </Form.Item> */}

                                {this.state.selectFormHistory && (
                                    <>
                                        <Form.Item
                                            // label="Vehicle No"
                                            label={this.context.translate("_VEHICLE_NO_")}
                                            name="vehicleId2"
                                            style={formItemStyle}
                                            rules={[{ required: true }]}
                                        >
                                            <Select
                                                onSelect={(val) => {
                                                    this.setState({ vehicleId: val });
                                                    this.getInformationOfVehicle({ vehicleId: val });
                                                }}
                                                showSearch
                                                filterOption={(inputValue, option) => {
                                                    if (option.children) {
                                                        return (
                                                            option.children
                                                                .toLowerCase()
                                                                .indexOf(inputValue.toLowerCase()) >= 0
                                                        );
                                                    }
                                                }}
                                            >
                                                {this.liveTrackingStore?.vehiclesArray?.map((val) => {
                                                    return (
                                                        <Option value={val.vehicleId}>
                                                            {val.vehicleNo}
                                                        </Option>
                                                    );
                                                })}
                                            </Select>
                                        </Form.Item>

                                        <Row>
                                            <Col span={11}>
                                                <Form.Item
                                                    // label="From Date"
                                                    label={this.context.translate("_FROM_DATE_")}
                                                    name="fromDate"
                                                    style={formItemStyle}
                                                >
                                                    <DatePicker
                                                        format={"MM-DD-YYYY"}
                                                        defaultValue={this.state.fromDate}
                                                        onChange={(val) =>
                                                            this.setState({
                                                                fromDate: val?.format("YYYY-MM-DD"),
                                                                toDate: val?.format("YYYY-MM-DD"),
                                                            })
                                                        }
                                                        disabledDate={(current) => {
                                                            return current && current > dayjs();
                                                        }}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col span={2}></Col>
                                            <Col span={11}>
                                                <Form.Item
                                                    // label="To Date"
                                                    label={this.context.translate("_TO_DATE_")}
                                                    name="toDate"
                                                    style={formItemStyle}
                                                >
                                                    <DatePicker
                                                        format={"MM-DD-YYYY"}
                                                        defaultValue={this.state.toDate}
                                                        disabledDate={(current) => {
                                                            return (
                                                                current &&
                                                                current < dayjs(this.state.fromDate)
                                                            ); // Updated condition
                                                        }}
                                                        onChange={(val) =>
                                                            this.setState({
                                                                toDate: val?.format("YYYY-MM-DD"),
                                                            })
                                                        }
                                                    />
                                                </Form.Item>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col span={11}>
                                                <Form.Item
                                                    // label="From Time"
                                                    label={this.context.translate("_FROM_TIME_")}
                                                    name="fromTime"
                                                    style={formItemStyle}
                                                    initialValue={"00:00:00"}
                                                >
                                                    <Select
                                                        onChange={this.setFromTime}
                                                        onSelect={(val) =>
                                                            this.setState({ fromTime: val })
                                                        }
                                                        // value={this.state.fromTime}

                                                        allowClear={true}
                                                    >
                                                        {this.timeOptions()}
                                                    </Select>
                                                </Form.Item>
                                            </Col>
                                            <Col span={2}></Col>
                                            <Col span={11}>
                                                <Form.Item
                                                    // label="To Time"
                                                    label={this.context.translate("_TO_TIME_")}
                                                    name="toTime"
                                                    style={formItemStyle}
                                                    initialValue={dayjs().format("hh:mm A")}
                                                >
                                                    <Select
                                                        onSelect={(val) => this.setState({ toTime: val })}
                                                        allowClear={true}
                                                    >
                                                        {this.timeOptions()}
                                                    </Select>
                                                </Form.Item>
                                            </Col>
                                        </Row>

                                        <Form.Item label=" ">
                                            <Button
                                                type="primary"
                                                onClick={this.LoadClick}
                                                style={{ width: "100%" }}
                                            >
                                                {/* Load */}
                                                {this.context.translate("_LOAD_")}
                                            </Button>
                                        </Form.Item>
                                        <Form.Item
                                            // label="Stop/Idle Points"
                                            label={this.context.translate("_STOP_IDLE_POINTS_")}
                                            name="stopIdlePoints"
                                        // style={formItemStyle}
                                        >
                                            <Select
                                                onChange={(val, b) => {
                                                    if (b.latLong?.length > 0) {
                                                        this.getInformationOfVehicle({
                                                            latLong: {
                                                                latitude: b?.latLong[0],
                                                                longitude: b?.latLong[1],
                                                            },
                                                        });
                                                    }
                                                }}
                                            >
                                                {this.liveTrackingStore.stopIdleArray?.map((val) => {
                                                    return (
                                                        <Select.Option
                                                            key={val.vehicleNo}
                                                            value={val.stopIdleLocation}
                                                            latLong={[val?.latitude, val?.longitude]}
                                                        // title={val.stopIdleLocation}
                                                        >
                                                            {val.stopIdleLocation}
                                                        </Select.Option>
                                                    );
                                                })}
                                            </Select>
                                        </Form.Item>
                                    </>
                                )}

                                <Form.Item
                                    // label="Type"
                                    label={this.context.translate(
                                        "_FLEET_DASHBORD_NEWPOI_TYPE_",
                                    )}
                                    name="typeName"
                                    style={formItemStyle}
                                >
                                    <Select>
                                        <Select.Option value={1}>
                                            {this.context.translate("_RETAILS_")}
                                        </Select.Option>
                                        <Select.Option value={2}>
                                            {this.context.translate("_FOOD_SERVICE_")}
                                        </Select.Option>
                                        <Select.Option value={3}>
                                            {this.context.translate(
                                                "_FLEET_DASHBORD_NEWPOI_TYPEDDL_WAREHOUSE_",
                                            )}
                                        </Select.Option>
                                        <Select.Option value={4}>
                                            {this.context.translate("_FLEET_CUSTOMER_")}
                                        </Select.Option>
                                        <Select.Option value={5}>
                                            {this.context.translate("_HEAD_OFFICE_")}
                                        </Select.Option>
                                        <Select.Option value={6}>
                                            {this.context.translate("_GARAGE_")}
                                        </Select.Option>
                                        <Select.Option value={7}>
                                            {this.context.translate("_OUTLET_")}
                                        </Select.Option>
                                        <Select.Option value={8}>
                                            {this.context.translate("_BRANCH_")}
                                        </Select.Option>
                                        <Select.Option value={9}>
                                            {this.context.translate("Store Start Point")}
                                        </Select.Option>
                                        <Select.Option value={10}>
                                            {this.context.translate("Common Area")}
                                        </Select.Option>
                                        <Select.Option value={11}>
                                            {this.context.translate("Taxi Zones")}
                                        </Select.Option>
                                    </Select>
                                </Form.Item>
                                <Form.Item
                                    // label="Speed"
                                    label={this.context.translate(
                                        "_FLEET_DASHBORD_SETTING_SPEED_",
                                    )}
                                    name="speed"
                                    style={formItemStyle}
                                >
                                    <Input />
                                </Form.Item>

                                <AddGeofenceFields />
                            </div>

                            <div className="formBtnGroup">
                                <Button
                                    onClick={async () => {

                                        await this.clearFields();
                                        this.removePlottedGeofences();
                                    }}
                                    style={{ fontSize: "11px" }}
                                    className="formCancelButton"
                                    type="primary"
                                >
                                    Discard &<br /> Create New
                                </Button>

                                <Button
                                    className="formCancelButton"
                                    onClick={() => {
                                        this.setState({ drawGeofence: false })
                                        this.removePlottedGeofences();
                                    }
                                    }
                                >
                                    {this.context.translate("_FLEET_CLOSE_BTN_")}
                                </Button>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    className="formSaveButton"
                                >
                                    {this.context.translate("_SUBMIT_")}
                                </Button>
                            </div>
                        </Form>
                    </Card>
                </div>
            )}
            {this.state.showGeofence && (
                <div>
                    <Draggable>
                        <Card
                            className="right-menu-panel showgeofence headerGroup-panel"
                            title={
                                <div
                                    style={{ display: "flex", justifyContent: "space-between" }}
                                >
                                    <div className="handle" style={{ cursor: "move" }}>
                                        {this.context.translate("_FLEET_DASHBORD_SHOWGEO_TITLE_")}
                                    </div>

                                    <CloseOutlined
                                        onClick={() => {
                                            this.removePlottedGeofences();
                                            this.setState({
                                                showGeofence: false,
                                                selectGeofenceObjects: [],
                                                geofenceData: [],
                                                selectGeofenceInList: [],
                                                selectGeofenceRows: [],
                                                company_value: null,
                                                // company_value:''
                                            });
                                            this.liveTrackingStore.geofenceListArray = [];
                                            this.liveTrackingStore.total = 0
                                        }}
                                    />
                                </div>
                            }
                            style={{ width: 400, padding: "20px" }}
                        >
                            <Row>
                                <Space style={{ marginBottom: "10px" }}>
                                    <CompanyAutocomplete
                                        style={{ width: "150px" }}
                                        // width={250}
                                        onClear={true}
                                        value={
                                            this.state.company_value
                                                ? this.state.company_value
                                                : null

                                        }
                                        onChange={async (value) => {
                                            await this.setState({ companyId: value.value });
                                            await this.handleGetGofenceList(value);
                                        }}
                                    />

                                    <Input
                                        placeholder={this.context.translate("_SEARCH_GEOFENCE_")}
                                        className="search-geofence-input"
                                        style={{ width: "185px" }}
                                        onChange={(e) => {
                                            this.setState({ searchGeoFence: e.target.value });
                                            this.searchInput(e);
                                        }}
                                        suffix={
                                            <Image
                                                src={searchIcon}
                                                style={{
                                                    width: "15.5px",
                                                    height: "21.5px",
                                                    flexShrink: 0,
                                                }}
                                            >
                                                {" "}
                                            </Image>
                                        }
                                    />
                                </Space>
                            </Row>
                            {console.log(this.liveTrackingStore.total, "this.liveTrackingStore.total")}
                            <Table
                                bordered
                                scroll={{ x: 300, y: 280 }}
                                rowSelection={{
                                    selectedRowKeys: this.state.selectGeofenceInList,
                                    selectedRows: this.state.selectGeofenceRows,
                                    onChange: async (selectedRowKeys, selectedRows) => {
                                        await this.setState({
                                            selectGeofenceInList: selectedRowKeys,

                                            selectGeofenceRows: selectedRows,
                                            showSelectedGeofence: selectedRows,
                                        });

                                        if (selectedRows) {
                                            this.showGeofencesOnMap(selectedRows);


                                        }
                                    },
                                }}
                                pagination={{
                                    currentPage: this.state.currentPage,
                                    pageSize: this.state.pageSize,
                                    total: this.liveTrackingStore.total,
                                }}
                                loading={this.liveTrackingStore?.loading}
                                rowKey="zoneId"
                                columns={this.showGeofenceListColumn}
                                dataSource={this.liveTrackingStore.geofenceListArray}
                                onChange={this.handleTableChange}
                            />

                            <div className="list-bottom-btns">

                                {/* <Tooltip
                                    title={this.context.translate(
                                        "_FLEET_DASHBORD_SHOWGEO_DELETE_",
                                    )}
                                    placement="bottom"
                                    color={config.tooltipColorDelete}
                                >
                                    <Button
                                        disabled={
                                            this.state.selectGeofenceInList?.length > 1
                                                ? false
                                                : true
                                        }
                                        // type="primary"
                                        icon={
                                            <DeleteOutlined
                                                style={{ color: "white", fontSize: "18px" }}
                                            />
                                        }
                                        onClick={async () => {
                                            this.deleteMultipleGeofence(
                                                this.state.selectGeofenceInList,
                                            );
                                        }}
                                    />
                                </Tooltip>
                                <Tooltip
                                    title={this.context.translate("_UPLOAD_FROM_EXCEL_")}
                                    color="blue"
                                    placement="bottom"
                                >
                                    <Button
                                        type="primary"
                                        onClick={async () =>
                                            await this.setState({
                                                showImportExcelModal: true,
                                                showGofence: false,
                                            })
                                        }
                                        icon={<i class="bi bi-cloud-upload"></i>}
                                    ></Button>
                                </Tooltip> */}
                                <Tooltip
                                    title={this.context.translate("_ADD_GEOFENCE_")}
                                    color="blue"
                                    placement="bottom"
                                >
                                    <Button
                                        type="primary"
                                        icon={<PlusOutlined />}
                                        onClick={async () => {

                                            await this.setState({ drawGeofence: true, drawGeoLocation: "", showGeofence: false });
                                            await this.geofenceCardTitle(
                                                this.context.translate("_NEW_GEOFENCE_"),
                                            );
                                            // if (this.state.geofenceId == -1) {
                                            //     this.setState({ geofenceCardTitle: "New Geofence" })
                                            // } else {
                                            //     this.setState({ geofenceCardTitle: "Update Geofence" })
                                            // }
                                        }}
                                    ></Button>
                                </Tooltip>
                            </div>
                        </Card>
                    </Draggable>
                </div>
            )}
        </>);
    }
}

PlotStudentsOnMap.contextType = StoreContext;
export default observer(withRouter(PlotStudentsOnMap));